import React from 'react';
import Price from 'atomic/utilization/price';
import Link from 'atomic/utilization/link';
import { useSelector } from '@ecommerce/nest-ssr/common';

import './product-best-offer.desktop.scss';
import OfferInterface from 'interfaces/offer.interface';
import { OffersState } from '../../../../reducers/offers';

const ProductBestOfferDesktop: React.FC = () => {
    const offer: OfferInterface = useSelector((state: { offers: OffersState; }) => state.offers?.prepared?.[0] || state.offers.items?.[0]);

    return offer
        ? (
            <Link className="best-offer sw gtm_or_chpst" rel="nofollow noopener noreferrer" href={offer.url}
                target="_blank" title="Sklep z najlepszą ofertą"
            >
                <div className="best-offer__shop">
                    <span className="best-offer__label">
                    Sklep z najlepszą ofertą:
                    </span>
                    { offer.dealer.logo && <img src={offer.dealer.logo} alt={offer.dealer.name}/> }
                </div>
                <div className="best-offer__price">
                    <span className="best-offer__label">
                    Cena:
                    </span>
                    <div className="best-offer__price-value">
                        <Price price={offer.price} size="xl" weight="700"/>
                    </div>
                </div>
                <button type="button" className="best-offer__button">
                Idź do sklepu
                </button>
            </Link>
        )
        : (
            <div className="best-offer__empty">
            Brak ofert dla tego produktu
            </div>
        );
};

export default ProductBestOfferDesktop;
